/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
import {abbreviatedMonths} from 'utils/months';
import format from 'material/chart/linechart/format'
// library
import { ResponsiveLine } from '@nivo/line'; // https://nivo.rocks/line/



/* ========== ~~~~~~~~~~ CHART : LINE : OVERVIEW : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const OverviewLineChart = (props) => {
    const handleCustomTooltip = (dataSlice) => {
        let date = new Date(dataSlice.id);
        return(
            <div style={{ color: '#bbb' }}>
                {dataSlice.data.map(d => (
                    <div
                        key={d.serie.id}
                        style={{
                            color: '#062B75',
                            padding: '3px 0',
                            display: 'flex',
                            flexDirection: 'row'
                        }}
                    >
                        <strong style={{marginRight: '10px'}}>{abbreviatedMonths[date.getUTCMonth()]} {date.getUTCDate()}</strong> <div>{format(d.data.y, props.metricType)}</div>
                    </div>
                ))}
            </div>
        )};

    return (
        <ResponsiveLine
            data={props.data}
            margin={{
                "top": 0,
                "right": 0,
                "bottom": 0,
                "left": 0
            }}
            xScale={{
                "type": "point"
            }}
            yScale={{
                "type": "linear",
                "stacked": true,
                "min": "auto",
                "max": "auto"
            }}
            curve="basis" // 'basis', 'cardinal', 'catmullRom', 'linear', 'monotoneX', 'monotoneY', 'natural', 'step', 'stepAfter', 'stepBefore'
            axisTop={null}
            axisRight={null}
            axisBottom={null}
            axisLeft={null}
            tooltip={slice => handleCustomTooltip(slice)}
            enableGridX={false}
            enableGridY={false}
            colorBy={d => d.color}
            lineWidth={4}
            enableDots={false}
            dotSize={10}
            dotColor="inherit:darker(0.3)"
            dotBorderWidth={2}
            dotBorderColor="#ffffff"
            dotLabel="y"
            dotLabelYOffset={-12}
            enableArea={true}
            areaOpacity={0.3}
            animate={true}
            motionStiffness={90}
            motionDamping={15}
            legends={[]}
        />
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default OverviewLineChart;